import { openModal } from 'modal'
import MemberMailchimpSubscribeFormModal from './MemberMailchimpSubscribeModal'
export const openMemberMailchimpSubscribeModal = () => openModal(MemberMailchimpSubscribeFormModal, {})
export { default as reducer } from './reducer'
